import {OEAsset, useClient, useDictionary, useOrderItem} from '@adamlip/okeoke.client';
import {Button, Divider, Drawer, DrawerBody, DrawerContent, Input, ScrollShadow} from '@heroui/react';
import OrderItemModalV3 from 'components/Modals/OrderItemModalV3';
import ModifierGroupSelector from 'components/Modals/OrderItemModalV3/ModifierGroupSelector';
import SizeSelector from 'components/Modals/OrderItemModalV3/SizeSelector';
import {useEffect, useState, useContext} from 'react';
import {Element} from 'react-scroll';
import {Switch} from '@heroui/react';
import {AppParamsContext} from 'contexts/AppParamsContext';
import BarSoftButton from 'components/_NewComponents/BarSoftButton';
import Icon from 'assets/icons';
import FormattedNumber from 'components/FormattedNumber';
import useBasket from 'hooks/useBasket';
import {MainContext} from 'contexts/MainContext';

function BasketItemModal({isOpen, setIsOpen, orderItemUUID}) {
	const {getName, tokenData} = useClient();
	const {appParams} = useContext(AppParamsContext);
	const {getValue} = useDictionary();
	const {noSafeAreaInTheApp} = useContext(MainContext);
	const {assembledItem, setCount, update, setNotes, setTakeAway, setSize, setModifierCount} = useOrderItem(null, null, orderItemUUID);

	const [itemNotes, setItemNotes] = useState('');
	const [allergens, setAllergens] = useState([]);
	const [showMore, setShowMore] = useState(false);
	const [itemModalOpen, setItemModalOpen] = useState(false);
	const {order, orderItemsAssembled} = useBasket();

	useEffect(() => {
		if (assembledItem != null && typeof setCount === 'function' && (assembledItem.count < 1 || assembledItem.count == null)) setCount(1);

		if (assembledItem != null) {
			let allergenArray = [];
			for (let [key, value] of Object.entries(assembledItem.allergens || {})) {
				if (value != null && value > 0) allergenArray.push(key);
			}
			setAllergens(allergenArray);
		}
		// eslint-disable-next-line
	}, [assembledItem]);
	const changeCount = (count) => {
		setCount(count);
	};
	const addItemToBasket = () => {
		update();
		setIsOpen(false);
	};
	const handleChangeNotes = (e) => setItemNotes(e.target.value);

	const handleBlurNotes = (e) => setNotes(itemNotes?.slice(0, 100));

	const handleAddAnotherClick = () => {
		setItemModalOpen(true);
		setIsOpen(false);
	};
	const removeItem = () => {
		order.updateBasketItemCount(orderItemUUID, 0);
		setCount(0);
		setTimeout(() => {}, 300);
		for (let childOrder of Object.values(orderItemsAssembled || {})?.filter((item) => item?.paxrentOrderItemUUID === orderItemUUID)) {
			order.updateBasketItemCount(childOrder?.orderItemUUID, 0);
		}
		update();
		setIsOpen(false);
	};
	const displayDescription = (description) => {
		const descriptionLength = description?.length;
		if (descriptionLength > 250) {
			return (
				<div className={`px-4 text-sm opacity-60 w-full ${showMore ? 'show-more-content show-more' : 'show-more-content'} ${appParams?.styles?.fonts?.capitalize ? 'font-bold !uppercase' : ''}`}>
					{showMore ? description : description.slice(0, 120) + '...'}
					<span className='ml-2 text-primary font-bold' onClick={() => setShowMore(!showMore)}>
						{showMore ? getValue('app_v2_showLess') : getValue('app_v2_showMore')}
					</span>
				</div>
			);
		} else {
			return <div className='px-4 text-sm opacity-60  text-clip w-full '>{description}</div>;
		}
	};

	if (assembledItem == null) return null;

	return (
		<>
			<OrderItemModalV3 isOpen={itemModalOpen} setIsOpen={setItemModalOpen} itemUUID={assembledItem.uuid} readOnly={false} />
			<Drawer
				isOpen={isOpen}
				onOpenChange={() => {
					setIsOpen(false);
				}}
				placement='bottom'
				size='full'
				classNames={{
					closeButton: `z-50 bg-primary text-primary-foreground ${noSafeAreaInTheApp ? 'top-14' : ''}`,
				}}>
				<DrawerContent className='!rounded-tl-modal !rounded-tr-modal overflow-hidden'>
					{(onClose) => (
						<>
							<DrawerBody className={`p-0 `}>
								<ScrollShadow className={`pb-16 realtive w-full grow overflow-x-hidden scrollArea !relative ${noSafeAreaInTheApp ? 'pt-0' : ''}`}>
									{noSafeAreaInTheApp && <div className='absolute top-0 left-0 right-0 h-24 bg-gradient-to-b from-background to-transparent z-10'></div>}
									{assembledItem.availability.available === 0 && <div className='orderItem-modal-notAvailable font-small text-center mb-1'>{getValue('app_v2_orderItem_notAvailable')}</div>}
									<div className='orderItem-modal-body ' id='scrollContainer'>
										{(appParams?.items?.showImage || appParams?.items?.showImage === undefined) && appParams?.assets?.defaultItemImg != null && (
											<OEAsset uuid={assembledItem.attributes.appImage} addClass={` w-full aspect-[4/3] max-h-[200px] flex flex-start overflow-hidden object-cover  ${appParams?.features?.imagesContain ? 'img-contain' : ''}`} size='l' />
										)}
									</div>
									<div className='z-50 sticky top-0 pt-4 bg-background'>
										<div className='px-4 pt-2 pb-2 flex flex-row gap-1 bg-background items-center !relative z-50'>
											<div id='desc' className='orderItem-modal-itemName font-extraLarge'>
												{getName(assembledItem.name)}
											</div>
										</div>
									</div>
									<div className='uppercase'>{displayDescription(getName(assembledItem.description))}</div>
									<div className='w-full flex flex-wrap gap-2 flex-row px-2'>
										{allergens.map((alle, index) => (
											<div key={index} className='allergen-icon'>
												<div className='w-6 h-6'>
													<Icon name={alle} className='fill-current' secondClassName={'fill-background/0'} />
												</div>
											</div>
										))}
									</div>
									<div className='px-2'>
										{allergens.length > 0 && (
											<span className=' text-small'>
												<span className='title'>- {getValue('app_v2_allergens')}: </span>
												{allergens.map((alle, index) => (
													<span key={index} className='allergen'>
														{getValue('app_v2_allergens_' + alle)}
														{allergens.length !== index + 1 && ', '}
													</span>
												))}
											</span>
										)}
										<div className='item-tags mt-2'>
											{Array.isArray(assembledItem.tags) && assembledItem.tags.includes('meat') && (
												<div className='w-6 h-6'>
													<Icon name={'meat'} className='fill-current' secondClassName={'fill-background/0'} />
												</div>
											)}
											{Array.isArray(assembledItem.tags) && assembledItem.tags.includes('lactoseFree') && (
												<div className='w-6 h-6'>
													<Icon name={'milk'} className='fill-current' secondClassName={'fill-background/0'} />
												</div>
											)}
											{Array.isArray(assembledItem.tags) && assembledItem.tags.includes('vegan') && (
												<div className='w-6 h-6'>
													<Icon name={'vegan'} className='fill-current' secondClassName={'fill-background/0'} />
												</div>
											)}
											{Array.isArray(assembledItem.tags) && assembledItem.tags.includes('glutenFree') && (
												<div className='w-6 h-6'>
													<Icon name={'glutenFree'} className='fill-current' secondClassName={'fill-background/0'} />
												</div>
											)}
										</div>
									</div>
									{assembledItem.sizes?.length > 1 && (
										<div className='orderItem-modal-itemSizes z-10 px-2'>
											<SizeSelector sizes={assembledItem.sizes} setSize={setSize} selectedSizeUUID={assembledItem.selectedSizeUUID} />
										</div>
									)}
									<div className=' px-4 flex flex-col gap-2 w-full z-0 !relative '>
										{assembledItem.modifierGroups
											.sort((a, b) => (a?.min > b?.min ? 1 : -1))
											.sort((a, b) => (a?.idx > b?.idx ? 1 : -1))
											.map((group, index) => {
												return (
													<Element key={group.uuid} name={group.uuid}>
														<ModifierGroupSelector key={group.uuid} group={group} setModifierCount={setModifierCount} readOnly={false} name={group?.uuid} />
														{index !== assembledItem.modifierGroups.length - 1 && <Divider className='my-4 bg-border' />}
													</Element>
												);
											})}
										{!(appParams?.items?.takeAwayHidden === true) && (
											<div className='orderItemModifierGroup-root'>
												<Switch isSelected={assembledItem.takeAway} onValueChange={() => setTakeAway(assembledItem.takeAway ? 0 : 1)}>
													{getValue('app_v2_orderItem_takeAway')}
												</Switch>
											</div>
										)}

										{!(appParams?.items?.notesHidden === true) && (
											<div className='orderItemModifierGroup-modifier-root orderItem-modal-notes font-small'>
												<Input
													aria-label='input'
													type='text'
													classNames={{
														inputWrapper: 'group-data-[focus=true]:bg-inputBackground border-1 rounded-general bg-inputBackground border-inputBorder text-inputText',
														label: appParams?.styles?.fonts?.capitalize ? 'font-bold uppercase' : '',
													}}
													name='itemNotes'
													label={getValue('app_v2_orderItem_notes')}
													value={itemNotes}
													fullWidth={true}
													onChange={handleChangeNotes}
													onBlur={handleBlurNotes}
												/>
											</div>
										)}
									</div>
								</ScrollShadow>
								<div className='w-full flex flex-row items-center justify-between px-4 pb-2  gap-4 z-10'>
									<div className='flex flex-row gap-2 w-auto items-center p-1 bg-secondaryBackground rounded-full'>
										<Button color='primary' radius='full' variant='solid' isDisabled={assembledItem?.count < 2} isIconOnly onPress={() => changeCount(assembledItem?.count - 1)}>
											<div className='w-6 h-6'>
												<Icon name='setMinus' className='stroke-current' />
											</div>
										</Button>
										<div className='min-w-[30px] flex items-center justify-center'>{+assembledItem?.count || 0}</div>
										<Button radius='full' color='primary' variant='solid' isIconOnly onPress={() => changeCount(assembledItem?.count + 1)}>
											<div className='w-5 h-5'>
												<Icon name='setPlus' className='stroke-current' />
											</div>
										</Button>
									</div>
									<BarSoftButton
										onPress={() => {
											removeItem();
										}}
										color='danger'
										radius='full'
										isIconOnly
										variant='flat'
										className={`  ${appParams?.styles?.fonts?.capitalize ? 'font-bold !uppercase' : ''}`}>
										<div className='w-6 h-6'>
											<Icon name='delete' className='fill-current' />
										</div>
									</BarSoftButton>
								</div>
								<div className='w-full px-2'>
									<BarSoftButton onPress={addItemToBasket} color='primary' buttonName='addToBasket' fullWidth isDisabled={assembledItem?.valid ? false : true} size='lg' className=' px-3 justify-start'>
										<div className={`w-full flex flex-row gap-2 items-center justify-between overflow-hidden`}>
											<span className='font-semibold'>{getValue('app_v2_refreshItem')}</span>
											<span className='min-w-[30px] flex items-center justify-center'>
												<FormattedNumber value={assembledItem?.totalPrice} />
											</span>
										</div>
									</BarSoftButton>
								</div>
								{appParams?.basketModal?.addItemWithDifferentOptions && (assembledItem?.sizes?.length > 1 || assembledItem?.modifierGroups?.length > 0) && (
									<BarSoftButton onPress={handleAddAnotherClick} fullWidth radius='none' className='w-full flex flex-row  items-center justify-center !pt-3 !pb-5 !h-auto z-10 bg-secondaryBackground rounded-tl-general rounded-tr-general'>
										<p className='text-medium text-primary'>{getValue('app_v2_addItemWithDifferentOption')}</p>
									</BarSoftButton>
								)}
								{noSafeAreaInTheApp && <div className='h-4 w-full' />}
							</DrawerBody>
						</>
					)}
				</DrawerContent>
			</Drawer>
		</>
	);
}

export default BasketItemModal;
